'use client';

import React from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';

const data = [
  { week: '30 Jun', ar: 142000, ap: 88000 },
  { week: '7 Jul',  ar: 158400, ap: 91200 },
  { week: '14 Jul', ar: 147800, ap: 84400 },
  { week: '21 Jul', ar: 172300, ap: 99800 },
  { week: '28 Jul', ar: 163400, ap: 94200 },
  { week: '4 Aug',  ar: 189200, ap: 102400 },
  { week: '11 Aug', ar: 176800, ap: 96600 },
  { week: '18 Aug', ar: 184320, ap: 97840 },
];

function fmt(v: number) {
  return `£${(v / 1000).toFixed(0)}k`;
}

const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: { name: string; value: number; color: string }[]; label?: string }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border shadow-md p-3 text-sm" style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}>
      <p className="font-semibold mb-2" style={{ color: 'var(--foreground)' }}>{label}</p>
      {payload.map((p) => (
        <div key={`tooltip-${p.name}`} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
          <span style={{ color: 'var(--slate)' }}>{p.name}:</span>
          <span className="font-semibold tabular-nums" style={{ color: 'var(--foreground)' }}>£{p.value.toLocaleString('en-GB')}</span>
        </div>
      ))}
    </div>
  );
};

export default function ARAPChart() {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <AreaChart data={data} margin={{ top: 4, right: 4, bottom: 0, left: 0 }}>
        <defs>
          <linearGradient id="gradAR" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="var(--accent)" stopOpacity={0.18} />
            <stop offset="95%" stopColor="var(--accent)" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="gradAP" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="var(--amber)" stopOpacity={0.18} />
            <stop offset="95%" stopColor="var(--amber)" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
        <XAxis dataKey="week" tick={{ fontSize: 11, fill: 'var(--slate)' }} axisLine={false} tickLine={false} />
        <YAxis tickFormatter={fmt} tick={{ fontSize: 11, fill: 'var(--slate)' }} axisLine={false} tickLine={false} width={44} />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ fontSize: '12px', paddingTop: '8px' }}
          formatter={(v) => <span style={{ color: 'var(--slate)' }}>{v}</span>}
        />
        <Area type="monotone" dataKey="ar" name="AR outstanding" stroke="var(--accent)" strokeWidth={2} fill="url(#gradAR)" />
        <Area type="monotone" dataKey="ap" name="AP owed" stroke="var(--amber)" strokeWidth={2} fill="url(#gradAP)" />
      </AreaChart>
    </ResponsiveContainer>
  );
}